import { useAuth } from '@/shared/lib/auth/auth-context'
import { canAccess } from './can-access'
import type { PermissionCheck } from './permission-values'

export function usePermissions() {
  const { user } = useAuth()

  return {
    can: (check: PermissionCheck) => canAccess(user, check),
    isSuperAdmin: user?.isSuperAdmin ?? false,
    isAdmin: user?.isAdmin ?? false,
    user,
  }
}
